import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "pb-8 pb-lg-10" }
const _hoisted_5 = { class: "fw-bolder text-dark" }
const _hoisted_6 = { class: "mb-0 pt-15" }
const _hoisted_7 = { class: "fs-3 text-gray-600 mb-5 w-75" }
const _hoisted_8 = { class: "text-gray-400 fw-bold fs-7 pt-5" }
const _hoisted_9 = { class: "text-gray-400 fw-bold fs-6 pt-1" }
const _hoisted_10 = {
  href: "tel:+18446277246",
  type: "submit",
  class: ""
}
const _hoisted_11 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_12 = { class: "text-gray-400 fw-bold fs-6 pt-15" }
const _hoisted_13 = {
  href: "/reports",
  class: "btn btn-lg btn-primary ctmscolor_background w-100"
}
const _hoisted_14 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "map-container" }
const _hoisted_17 = { id: "contet" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { id: "siteNotice" }, null, -1)
const _hoisted_19 = { class: "text-gray-800 fw-bolder" }
const _hoisted_20 = { id: "bodyContent" }
const _hoisted_21 = { style: {"text-transform":"capitalize"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InfoWindow = _resolveComponent("InfoWindow")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("Clinical Trial Matching Results are Ready")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(
                  "Our patient relations coordinator will contact you to give more information and answer any questions you have."
                )), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("You can contact us any time at the number below.")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("MassiveBioPhoneNumberLabel")) + " ", 1),
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.$t("Go to Report")) + " ", 1),
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_GoogleMap, {
          "api-key": "AIzaSyCjvW6_n3FT5KUvbyiT2JU71YVKXQihpr0",
          "map-type-id": "terrain",
          style: {"width":"100%","height":"378px"},
          center: _ctx.center,
          zoom: 4,
          ref: "mapRef"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marker_positions3, (location) => {
              return (_openBlock(), _createBlock(_component_Marker, {
                key: location.id,
                options: {
              position: { ...location.position },
              animation: true,
            }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InfoWindow, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("h4", _hoisted_19, _toDisplayString(location.infowindow["trial_code"]
                      ? location.infowindow["trial_code"]
                      : ""), 1),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("p", null, _toDisplayString(location.infowindow["title_of_clinical_trial"]), 1),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(location.infowindow["recruitment_status"]), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["options"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["center"]),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}